import { render, staticRenderFns } from "./emailRegistrationComponent.vue?vue&type=template&id=c5286b0c"
import script from "./emailRegistrationComponent.vue?vue&type=script&lang=js"
export * from "./emailRegistrationComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports